import axios from "axios";
import AesRsaUtils from "./aes_rsa";
// 基础的请求地址
let baseURL = "";
baseURL =
  process.env.NODE_ENV === "development"
    ? "http://47.99.91.179:7013"
    : "https://dor.fyytjzx.com:4443";
const service = axios.create({
  baseURL,
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    //生成AES密钥
    const aesKey = AesRsaUtils.generateAesKey();
    //使用RSA加密AES密钥
    const encryptedAesKey = AesRsaUtils.rsaEncrypt(aesKey);
    config.headers["sign"] = encryptedAesKey;
    config.headers["timestamp"] = new Date().getTime();
    if (config.url.indexOf("uploadFile") > 0) {
      if (localStorage.getItem("tsToken")) {
        config.headers["tsToken"] = localStorage.getItem("tsToken");
      }
    } else {
      if (config?.data) {
        const aesData = AesRsaUtils.aesEncrypt(
          JSON.stringify(config.data),
          aesKey
        );
        config.data = { requestData: aesData };
      }
    }
    return config;
  },
  (error) => {
    //   对请求错误做些什么
    console.log(error);
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject();
  }
);

// 响应拦截器,例如判断服务器返回的状态，400，500，其实超时可以写到这里面来，我分开写了一个比较直观
service.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return Promise.resolve(response.data);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况,这些自定义（需要与后台商量返回）
  (error) => {
    if (error.response.status >= 400 < 500) {
      // localStorage.removeItem("token");
      // 跳转登录
    } else {
      if (error.response.status >= 500) {
        alert("服务器开小差了，请稍后再试！");
      } else {
        alert("服务器开小差了，请稍后再试！");
        return Promise.reject(error);
      }
    }
  }
);

export default service;
